import { PulseKpis } from "./PulseKpis";
import {
  DeliveryTable,
  FixedCostsCard,
  HoursCard,
  StageFunnel,
} from "./PulseWidgets";
import { RevenueChart } from "./RevenueChart";
import { usePulseData } from "./usePulseData";

/**
 * View B «Pulso del negocio» (desktop): money first. KPIs → revenue and
 * funnel → deliveries, hours and fixed costs. Widgets whose resource the
 * data provider lacks are left out.
 */
export const HomePulse = () => {
  const data = usePulseData();
  const bottom = [
    data.deliveries ? (
      <DeliveryTable key="deliveries" rows={data.deliveries} />
    ) : null,
    data.hours ? (
      <HoursCard key="hours" hours={data.hours} deals={data.deals} />
    ) : null,
    data.costs ? <FixedCostsCard key="costs" costs={data.costs} /> : null,
  ].filter(Boolean);

  return (
    <div className="home-b">
      <PulseKpis data={data} />
      <div className="home-b__row">
        {data.invoicing ? <RevenueChart rows={data.invoicing.revenue} /> : null}
        <StageFunnel stages={data.funnel} overdue={data.overdueClosings} />
      </div>
      {bottom.length > 0 ? (
        <div className="home-b__bottom" data-count={bottom.length}>
          {bottom}
        </div>
      ) : null}
    </div>
  );
};
